<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    return-object
    item-text="title"
    :items="classrooms"
    item-value="id"
    @change="onChange"
    v-on:input="$emit('input', $event)"
    clearable
    :loading="loading"
  >
    <template v-slot:[`item`]="{ item }"
      >Phòng {{ item.name }} (Toà {{ item.building }}, Tầng {{ item.floor }}) ({{ item.capacity }} chỗ ngồi)</template
    >
    <template v-slot:[`selection`]="{ item }"
      ><span class="pt-2">Phòng {{ item.name }} (Toà {{ item.building }}, Tầng {{ item.floor }}) ({{ item.capacity }} chỗ ngồi)</span></template
    >
  </v-autocomplete>
</template>

<script>
import { Classroom } from '@/plugins/api'

export default {
  data: () => ({
    classrooms: [],
    loading: false,
  }),
  props: {
    filters: Object,
    defaultClassroom: Array,
    options: Object,
  },
  created() {
    if (this.defaultClassroom) {
      this.classrooms = this.defaultClassroom
    }

    this.fetchAll()
  },
  methods: {
    async fetchAll(query) {
      this.loading = true
      const params = {
        ...this.filters,
        ...query,
        _sort: 'gradeNumber:ASC',
        _limit: -1,
      }
      this.classrooms = await Classroom.fetch(params)
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filters(newVale) {
      if (newVale) this.fetchAllGrades(newVale)
    },
  },
}
</script>

<style scoped></style>
